export const initializeStores = async () => {
  await (await import('./product/product.connection')).initializeProductStore();
  await (await import('./products/products.connection')).initializeProductsStore();
  await (await import('./contextBar/contextBar.connection')).initializeContextBarStore();
  await (await import('./localFootnotes/local-footnotes.connection')).initializeLocalFootnotesStore();
  await (await import('./dealerContext/dealerContext.connection')).initializeDealerContextStore();
};
